
		import Async from "../../../node_modules/.pnpm/@preact+async-loader@https+++registry.npmmirror.com+@preact+async-loader+-+async-loader-3.0.2_y7ebjw3nl6eun3ftqy7sbhg6rm/node_modules/@preact/async-loader/async.js";

		function load(cb) {
			require.ensure([], function (require) {
				var result = require("!!../../../node_modules/.pnpm/babel-loader@https+++registry.npmmirror.com+babel-loader+-+babel-loader-8.3.0.tgz_@babel+core_cjg7r4wlbznqfpb2xbhzxkj2ra/node_modules/babel-loader/lib/index.js??ref--4!./index.tsx");
				typeof cb === 'function' && cb(result);
			}, "route-seal");
		}

		export default Async(load);
	